import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnBetalingen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M32.88 12.01H7.12a1.11 1.11 0 0 0-1.11 1.11v13.76c0 .613.497 1.11 1.11 1.11h25.76a1.11 1.11 0 0 0 1.11-1.11V13.12a1.11 1.11 0 0 0-1.11-1.11"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M8 19h12M8 21h5"
    />
    <path
      fill="#fff"
      d="M34 15H6.02v1.98H34z"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M19.99 18c3.25 0 5.89 2.64 5.89 5.89V34.3H14.1V23.89c0-3.25 2.64-5.89 5.89-5.89"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M20.01 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnBetalingen);

export default ForwardRef;
